import classnames from "classnames";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { useViewport } from "shared/contexts/ViewportContext";

import Card from "features/components/Card";
import Typography from "features/components/Typography";
import { RowData } from "features/ui/MaterialTable";

interface Props {
  data: RowData[];
  accessors: string[];
  title?: string;
}

/**
 * TableCard
 *
 * A card component that displays tabular data using the accessors array.
 */

export const TableCard = ({ data, accessors, title }: Props) => {
  const { isMobile } = useViewport();

  return (
    <Card className="p-0! mb-4">
      <Stack
        className="border-b h-10 p-4 border-gray-100 bg-slate-50 items-center"
        direction="row"
      >
        {title && (
          <Box>
            <Typography variant="h4">{title}</Typography>
          </Box>
        )}
      </Stack>
      <Stack className="p-3">
        {data.map((item, index) => (
          <Stack
            key={index}
            direction="row"
            className="py-1 items-center border-b border-gray-50"
          >
            {accessors.map((field, i) => (
              <Box
                className={classnames("flex-1 flex-wrap wrap-break-word", {
                  "font-bold": i !== 0,
                  "text-sm": isMobile,
                  "text-xs": !isMobile,
                })}
                key={`${field}_${index}`}
              >
                {item[field]}
              </Box>
            ))}
          </Stack>
        ))}
      </Stack>
    </Card>
  );
};
